import styled from 'styled-components';

import { size } from '../../layout/helpers';
import { fadeIn } from '../../layout/keyframes';
import { ButtonReset } from '../../layout/reset';

export const ActionButton = styled(ButtonReset).withConfig({ componentId: 'sc-198fdj7-0' })`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${size(4.5)};
    height: ${size(4.5)};
    background-color: var(--c-bg-main);
    color: var(--c-text-main);
    border-radius: 50%;
    box-shadow: 0 1px 5px rgba(var(--c-overlay-rgb), 0.2);
    font-size: ${(props) => props.theme.font.size.regular};
    transform-origin: 50% 50%;
    transition: transform 200ms ease;
    animation: ${fadeIn} 400ms ease;

    &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: inherit;
        box-shadow: 0 1px 20px rgba(var(--c-overlay-rgb), 0.2);
        opacity: 0;
        transition: opacity 200ms ease;
    }

    &:active {
        transform: scale(0.95);
    }

    &:hover {
        &:before {
            opacity: 1;
        }
    }
`;
